// @flow

import type CurrentUser from 'models/CurrentUser';

export const CURRENT_USER_EDIT: 'current-user/edit' = 'current-user/edit';
export const CURRENT_USER_REMOVE: 'current-user/delete' = 'current-user/delete';
export const CURRENT_USER_LOADED: 'current-user/loaded' = 'current-user/loaded';
export const CURRENT_USER_POLLING_LOADED: 'current-user/polling/loaded' =
  'current-user/polling/loaded';
export const CURRENT_USER_LOAD_ERROR: 'current-user/load-error' =
  'current-user/load-error';
export const USER_RENTAL_MONTHS_BY_RENT: 'user/rental-months/by-rent' =
  'user/rental-months/by-rent';
export const USER_CARDS: 'current-user/cards' = 'current-user/cards';
export const LEGAL_ENTITY_CREATE: 'legal-entity/create' = 'legal-entity/create';
export const LEGAL_ENTITY_EDIT: 'legal-entity/edit' = 'legal-entity/edit';
export const SET_LAST_CODE_DATE: 'current-user/last-code-date' =
  'current-user/last-code-date';

export type Action =
  | {
      type: typeof CURRENT_USER_REMOVE
    }
  | {
      type: typeof CURRENT_USER_LOADED,
      currentUser: CurrentUser
    }
  | {
      type: typeof CURRENT_USER_LOAD_ERROR,
      error: Error
    }
  | {
      type: typeof CURRENT_USER_EDIT,
      params: {}
    }
  | {
      type: typeof USER_RENTAL_MONTHS_BY_RENT,
      data: {},
      metadata: {}
    }
  | {
      type: typeof USER_CARDS,
      cards: {}
    }
  | {
      type: typeof LEGAL_ENTITY_CREATE,
      data: {}
    }
  | {
      type: typeof LEGAL_ENTITY_EDIT,
      data: {}
    }
  | {
      type: typeof CURRENT_USER_POLLING_LOADED,
      currentUser: {}
    };
